import Vue from 'vue';
import { submitAddress, getUserAddress } from './api';

// 我的奖品页
export default {
  namespaced: true,
  state() {
    return {
      userAddress: null,
      submitUserAddressComplete: false
    };
  },
  actions: {
    async submitAddress({ commit }, data) {
      Vue.prototype.$hll.showLoading({});
      try {
        await submitAddress(data);
        commit('submitUserAddressSuccess');
      } catch (error) {
        Vue.prototype.$hll.toast(error && error.msg);
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }
    },
    async getUserAddress({ commit }) {
      let result;
      try {
        result = await getUserAddress();
      } catch (error) {
        Vue.prototype.$hll.toast(error && error.msg);
        throw error;
      }
      if (result) {
        commit('setUserAddress', result);
      }
    }
  },
  mutations: {
    setUserAddress(state, addressObj) {
      state.userAddress = addressObj;
    },
    submitUserAddressSuccess(state) {
      state.submitUserAddressComplete = true;
    }
  }
};
